import { render, staticRenderFns } from "./clueTaskAdd.vue?vue&type=template&id=f5aefdd2&scoped=true"
import script from "./clueTaskAdd.vue?vue&type=script&lang=js"
export * from "./clueTaskAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5aefdd2",
  null
  
)

export default component.exports